import React, { useRef, useState } from "react"
import { useAuth } from "../contexts/AuthContext"
import { Box, Stack, Typography, Alert, TextField, Button, Link } from "@mui/material"


export default function ForgotPassword() {
  const emailRef = useRef()
  const { resetPassword } = useAuth()
  const [error, setError] = useState("")
  const [message, setMessage] = useState("")
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()

    try {
      setMessage("")
      setError("")
      setLoading(true)
      await resetPassword(emailRef.current.value)
      setMessage("Check your inbox for further instructions")
    } catch {
      setError("Failed to reset password")
    }

    setLoading(false)
  }

  return (
    <>
 

      <Box component="form" onSubmit={handleSubmit}>
        <Stack spacing={2} alignItems="center">
        <Typography variant="h1" sx={{ fontWeight: 'bold', fontSize: '2.25vw', marginTop: "20px", fontFamily: 'Prompt' }}>รีเซ็ตรหัสผ่าน</Typography>
              {error && <Alert severity="error">{error}</Alert>}
              {message && <Alert severity="success">{message}</Alert>}
        <TextField label="Email" id="email" variant="standard" type="email" inputRef={emailRef} inputProps={{ style: { fontFamily: "Prompt" } }}
          InputLabelProps={{ style: { fontFamily: "Prompt" } }}/>
          <Button  disabled={loading}  type="submit" variant="contained" sx={{fontFamily: 'Prompt' }}>รีเซ็ตรหัสผ่าน</Button>
          <Link href="/login" sx={{fontFamily: 'Prompt' }}>เข้าสู่ระบบ</Link>
        </Stack>

      </Box>


    </>
  )
}